import { render, staticRenderFns } from "./PregledTura.vue?vue&type=template&id=212f153a&"
import script from "./PregledTura.vue?vue&type=script&lang=ts&"
export * from "./PregledTura.vue?vue&type=script&lang=ts&"
import style0 from "./PregledTura.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports